export default "__VITE_ASSET__Bo3$99wD__"